import http from '@/utils/services/http'

export function list (limit, page, filtros) {
  return http.get('/api/policiacivil/notificacao-telegrama/?page=' + page + '&limit=' + limit + filtros)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function cadastrar (data, id = null) {
  if (id) return update(data, id)

  return http.post('/api/policiacivil/notificacao-telegrama', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function find (id) {
  id = parseInt(id)
  if (id < 1) return Promise.reject()
  return http.get('/api/policiacivil/notificacao-telegrama/' + id)
      .then(response => {
        console.log(response)
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function update (data, id) {
  return http.patch('/api/policiacivil/notificacao-telegrama/' + id + '/update', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function deleteTelegrama (id) {
  return http.delete('/api/policiacivil/notificacao-telegrama/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function situacoes () {
  return http.get('/api/policiacivil/notificacao-telegrama/situacoes')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function listByGrv (grvId) {
  return http.get(`/api/policiacivil/notificacao-telegrama/grv/${grvId}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}

export function uploadArquivo (grvId, file) {
  return http.post(`/api/policiacivil/notificacao-telegrama/grv/${grvId}/upload-pdf`, file)
    .then(result => Promise.resolve(result))
    .catch(error => Promise.reject(error))
}



// WEBPACK FOOTER //
// ./src/domain/policia-civil/notificacao-telegrama/services/notificacao-telegrama.js